import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { DynamicTable } from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";

import {
    setIsAddCustomerAccountModalClicked,
    storeCustomerAccount,
} from "../store";
import { store } from "../../../../components/VerticalLayout/store";

import ModalInfo from "../ModalInfo";
import { CustomIcons } from "./CustomIcons";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import CustomColumnDisplay from "@components/Common/CustomColumnDisplay";

export default function CustomerAccounts(franchise: any) {
    const { t } = useTranslation();
    const { oneShop, franchiseID, userID } = useSnapshot(store);
    const uuidUser = localStorage.getItem("uuidUser");
    const url = `${process.env.REACT_APP_API_V2_URL}/settings/general/get_list_shops?userId=${userID}&franchiseId=${franchiseID}&uuidUser=${uuidUser}`;

    const [, setSelectedRows] = useState<any>([]);
    const [costumerName, setCostumerName] = useState<string>("");

    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const { isAddCustomerAccountModalClicked } = useSnapshot(
        storeCustomerAccount
    );
    const ActionColumn = (e: any) => {
        return e.selectedRow.subRows === undefined ? <div></div> : null;
    };
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    type CustomColumnProps = {
        indexOFColumn: number;
        columnName: string;
        customJsx: React.ReactNode;
    };

    let arrayOfCustomColumns: CustomColumnProps[] = [
        {
            indexOFColumn: 3,
            columnName: t("Adresse"),
            customJsx: (e: any) => (
                <CustomColumnDisplay text={e.selectedRow.Adresse} />
            ),
        },
        {
            indexOFColumn: 9,
            columnName: t("Tag"),
            customJsx: (e: any) => (
                <CustomColumnDisplay
                    text={e.selectedRow.Tag.map(
                        (el: any) => el.designation
                    ).join()}
                />
            ),
        },

        {
            indexOFColumn: 999,
            columnName: t("Action"),
            customJsx: (e: any) => (
                <CustomIcons
                    e={e}
                    setIsAddCustomerAccountModalClicked={
                        setIsAddCustomerAccountModalClicked
                    }
                    isAddCustomerAccountModalClicked={
                        isAddCustomerAccountModalClicked
                    }
                    setCostumerName={setCostumerName}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                />
            ),
        },
    ];

    return (
        <React.Fragment>
            <div
                style={{
                    display: "grid",
                    minHeight: oneShop ? "650px" : "600px",
                    gridTemplateColumns: "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    url={url}
                    canExpand={false}
                    canSelect
                    requestHeader={{ "Accept-Language": i18nextLng }}
                    customSelect
                    setSelectedRows={setSelectedRows}
                    customJsxSideFilterButton={
                        <React.Fragment></React.Fragment>
                    }
                    canResize
                    actionColumn={ActionColumn}
                    showGlobalFilter
                    showFilter
                    dataIsUpdated={dataIsUpdated}
                    setDataIsUpdated={setDataIsUpdated}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    elevationTable={1}
                    minHeight={oneShop ? "500px" : "450px"}
                    maxHeight={oneShop ? "500px" : "450px"}
                    name="CustomerAccount"
                />
                {isAddCustomerAccountModalClicked && (
                    <ModalInfo
                        isAddCustomerAccountModalClicked={
                            isAddCustomerAccountModalClicked
                        }
                        setIsAddCustomerAccountModalClicked={
                            setIsAddCustomerAccountModalClicked
                        }
                        costumerName={costumerName}
                        setDataIsUpdated={setDataIsUpdated}
                    />
                )}
            </div>
        </React.Fragment>
    );
}
